<template>
<div>
  <div>
    <div class="mt-4" style="font-size: .9em;">
      <p style="font-weight: bolder">La contraseña debería cumplir con los siguientes requerimientos:</p>

      <p style="margin-bottom: 0px;"
         v-bind:class="longitud ? 'text-success':'text-danger'">
        <b-icon
            :icon="longitud ? 'check-circle':'x-circle'"
            :variant="longitud ? 'success':'danger'">
        </b-icon>
        Debería tener <b>8 caracteres</b> como mínimo.
      </p>

      <p style="margin-bottom: 0px;"
         v-bind:class="minusculas ? 'text-success':'text-danger'">
        <b-icon
            :icon="minusculas ? 'check-circle':'x-circle'"
            :variant="minusculas ? 'success':'danger'">
        </b-icon>
        Debe tener: Al menos debería tener <b>una letra minúscula</b>.
      </p>

      <p style="margin-bottom: 0px;"
         v-bind:class="mayusculas ? 'text-success':'text-danger'">
        <b-icon
            :icon="mayusculas ? 'check-circle':'x-circle'"
            :variant="mayusculas ? 'success':'danger'">
        </b-icon>
        Debe tener: Al menos <b>una letra en mayúsculas</b>.
      </p>

      <p style="margin-bottom: 0px;"
         v-bind:class="caracteres ? 'text-success':'text-danger'">
        <b-icon
            :icon="caracteres ? 'check-circle':'x-circle'"
            :variant="caracteres ? 'success':'danger'">
        </b-icon>
        Debe tener: Al menos <b>un caracter especial</b> como mínimo.
      </p>

      <p v-bind:class="numeros ? 'text-success':'text-danger'">
        <b-icon
            :icon="numeros ? 'check-circle':'x-circle'"
            :variant="numeros ? 'success':'danger'">
        </b-icon>
        Debe tener: Al menos <b>un número</b>.
      </p>

    </div>
  </div>
</div>
</template>

<script>
export default {
  name: "contraseniaValidacionRobusta",
  props: {
    contrasenia: String
  },
  data() {
    return {
      longitud: false,
      minusculas: false,
      mayusculas: false,
      numeros: false,
      caracteres: false,
      cumpleCondicionesPassword: false
    };
  },
  watch: {
    contrasenia: function () {
      this.validarPass();
      if (
          this.longitud &&
          this.minusculas &&
          this.mayusculas &&
          this.numeros &&
          this.caracteres
      ) {
        this.cumpleCondicionesPassword = true;
      } else {
        this.cumpleCondicionesPassword = false;
      }
      this.$emit('cumpleCondicionesPassword', this.cumpleCondicionesPassword);
    }
  },
  methods:{
    validarPass() {
      if (/[0-9]/.test(this.contrasenia)) this.numeros = true;
      else this.numeros = false;

      if (/[a-z]/.test(this.contrasenia)) this.minusculas = true;
      else this.minusculas = false;

      if (/[A-Z]/.test(this.contrasenia)) this.mayusculas = true;
      else this.mayusculas = false;

      if (/[$%!@.#]/.test(this.contrasenia)) this.caracteres = true;
      else this.caracteres = false;

      if (this.contrasenia.length >= 8) this.longitud = true;
      else this.longitud = false;
    }
  }
}
</script>

<style scoped>

</style>
